import {
  ChevronsUp,
  CircleHelp,
  type LucideIcon,
  TrendingDown,
  TrendingUp,
  TriangleAlert,
} from 'lucide-react';
import type { BadgeProps } from '@/components/ui/badge';
import type { ProfitLevel } from '../api/products';

/**
 * Ícone e variante do `Badge` por nível (ADR-043: cor pela variante, por token). Os extremos —
 * prejuízo, margem baixa, acima da meta — são sólidos, para saltar aos olhos numa lista longa; o
 * lucrativo normal é tingido, que é o estado que não pede nada. `soft` é o provisório (tracejado).
 */
export const PROFIT_LEVEL_STYLES: Record<
  ProfitLevel,
  { icon: LucideIcon; solid: BadgeProps['variant']; soft: BadgeProps['variant'] }
> = {
  LOSS: { icon: TrendingDown, solid: 'destructive', soft: 'destructive-soft' },
  LOW: { icon: TriangleAlert, solid: 'warning', soft: 'warning-soft' },
  GOOD: { icon: TrendingUp, solid: 'success-soft', soft: 'success-soft' },
  GREAT: { icon: ChevronsUp, solid: 'excellent', soft: 'excellent-soft' },
  NO_COST: { icon: CircleHelp, solid: 'neutral', soft: 'neutral' },
};
